'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _customButtonIcon = require('./customButtonIcon.js');

var _customButtonIcon2 = _interopRequireDefault(_customButtonIcon);

var _index = require('../../../utils/index.js');

var _index2 = _interopRequireDefault(_index);

var _biLogger = require('photography-client-lib/dist/src/utils/biLogger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomButton = function (_React$Component) {
  (0, _inherits3.default)(CustomButton, _React$Component);

  function CustomButton() {
    (0, _classCallCheck3.default)(this, CustomButton);
    return (0, _possibleConstructorReturn3.default)(this, (CustomButton.__proto__ || (0, _getPrototypeOf2.default)(CustomButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(CustomButton, [{
    key: 'render',
    value: function render() {
      var styleParams = this.props.styleParams;

      var defaultText = _index2.default.isStoreGallery() ? 'Buy Now' : 'Click here';
      var buttonText = styleParams.customButtonText || defaultText;
      return _react2.default.createElement(
        'div',
        { className: 'custom-button-wrapper', style: { justifyContent: styleParams.galleryHorizontalAlign } },
        this.props.small ? _react2.default.createElement(_customButtonIcon2.default, null) : _react2.default.createElement(
          'button',
          { 'data-hook': 'custom-button-button', onClick: function onClick() {
              return _biLogger.logger.trackBi(_biLogger.logger.biEvents.buyNowClick);
            },
            tabIndex: -1
          },
          buttonText,
          _react2.default.createElement('div', { className: 'overlay' })
        )
      );
    }
  }]);
  return CustomButton;
}(_react2.default.Component);

exports.default = CustomButton;